module.exports = __webpack_public_path__ + "static/media/BillRed.ccc58902.png";